// Web immediate black background CSS (extracted to constant per cursor rules)
// Note: overflow is NOT hidden here to allow scrolling on landing page
// Overflow is only hidden on authenticated routes via getWebFullscreenStyles()
const WEB_IMMEDIATE_BLACK_BG_CSS = `
  html, body {
    background-color: #000000 !important;
    margin: 0 !important;
    padding: 0 !important;
  }
`;

// Must match src/shared/constants/webDocument.constants.ts WEB_VIEWPORT_META_CONTENT.
// Metro dev HTML sometimes lacks viewport before +html is applied; production static export usually has it.
if (typeof document !== 'undefined' && document.head) {
  if (!document.querySelector('meta[name="viewport"]')) {
    const viewport = document.createElement('meta');
    viewport.name = 'viewport';
    viewport.content =
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
    document.head.appendChild(viewport);
  }
  const style = document.createElement('style');
  style.textContent = WEB_IMMEDIATE_BLACK_BG_CSS;
  document.head.insertBefore(style, document.head.firstChild);
  if (document.body) {
    document.body.style.backgroundColor = '#000000';
  }
}

// MUST stay above every other import. Installs `globalThis.expo` synchronously
// so `expo-router` / `expo-linking` / `expo-modules-core` don't read it as
// undefined when their modules initialize. See ./expo-global-polyfill.js.
import './expo-global-polyfill';

// Earliest TestFlight launch marker (filter Console.app with ZPORTI_LAUNCH).
if (typeof globalThis !== 'undefined') {
  // eslint-disable-next-line no-console
  console.warn('[ZPORTI_LAUNCH] phase=js_entry elapsedMs=0');
}

// `@expo/metro-runtime` is imported next so Fast Refresh still hooks in early on web.
import '@expo/metro-runtime';

// Ignore Expo keep-awake errors on web (keep-awake not supported in browser)
if (typeof window !== 'undefined' && window.addEventListener) {
  window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message ?? String(event.reason);
    if (msg.includes('Unable to activate keep awake')) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
}

import { App } from 'expo-router/build/qualified-entry';
import { renderRootComponent } from 'expo-router/build/renderRootComponent';
import registerRootComponent from 'expo/src/launch/registerRootComponent';

if (process.env.EXPO_PUBLIC_STORYBOOK_ENABLED === "true") {
  registerRootComponent(require("./.rnstorybook").default);
} else {
  renderRootComponent(App);
}


